import { render, staticRenderFns } from "./panel.vue?vue&type=template&id=4054dcdd"
import script from "./panel.vue?vue&type=script&lang=ts"
export * from "./panel.vue?vue&type=script&lang=ts"
import style0 from "./panel.vue?vue&type=style&index=0&id=4054dcdd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports